(function () {
  var MESES = { ene: 'enero', feb: 'febrero', mar: 'marzo', abr: 'abril', may: 'mayo', jun: 'junio', jul: 'julio', ago: 'agosto', sep: 'septiembre', sept: 'septiembre', oct: 'octubre', nov: 'noviembre', dic: 'diciembre' };
  var MAPA = '<svg class="vz-pais" viewBox="0 0 18 12" role="img" aria-label="Colombia"><rect width="18" height="6" fill="#FCD116"/><rect y="6" width="18" height="3" fill="#003893"/><rect y="9" width="18" height="3" fill="#CE1126"/></svg>';
  var RE = /^\s*(\d{1,2})\s+([a-zñáéíóú]+)\.?\s+(\d{4})\s*$/i;

  function fecha(el) {
    if (el.dataset.vzf) return;
    var m = RE.exec(el.textContent);
    if (!m) return;
    var mes = MESES[m[2].toLowerCase().slice(0, 4)] || MESES[m[2].toLowerCase().slice(0, 3)] || m[2].toLowerCase();
    el.dataset.vzf = '1';
    el.innerHTML = 'Reseñado en Colombia ' + MAPA + ' el ' + m[1] + ' de ' + mes + ' de ' + m[3];
  }

  function pasar() {
    var raiz = document.getElementById('cont-rl-w');
    if (!raiz) return;
    var fechas = raiz.querySelectorAll('.rvp-row .rvp-dim');
    for (var i = 0; i < fechas.length; i++) fecha(fechas[i]);
  }

  var t;
  function luego() { clearTimeout(t); t = setTimeout(pasar, 50); }


  function base(u) { return (u || '').split('?')[0]; }

  function esperar(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  async function cargarMas(boton) {
    var raiz = document.getElementById('cont-rl-w');
    var grid = raiz && raiz.querySelector('.rvp-gal-grid');
    if (!grid) return;
    boton.disabled = true;

    for (var i = 0; i < 6; i++) {
      var mas = raiz.querySelector('.rvp-more');
      if (!mas || mas.hidden || getComputedStyle(mas).display === 'none') break;
      var antes = raiz.querySelectorAll('.rvp-row').length;
      mas.click();
      await esperar(350);
      if (raiz.querySelectorAll('.rvp-row').length === antes) break;
    }

    var vistas = {};
    grid.querySelectorAll('img').forEach(function (im) { vistas[base(im.getAttribute('src'))] = 1; });
    var primera = null;
    raiz.querySelectorAll('.rvp-row-media img, .rvp-row-media video').forEach(function (m) {
      var src = m.getAttribute('src') || m.getAttribute('poster');
      if (!src || vistas[base(src)]) return;
      vistas[base(src)] = 1;
      var tile = document.createElement('img');
      tile.src = src;
      tile.alt = '';
      tile.loading = 'lazy';
      tile.addEventListener('click', function () { m.click(); });
      grid.insertBefore(tile, boton);
      if (!primera) primera = tile;
    });

    boton.hidden = true;
    boton.style.display = 'none';
    if (primera) {
      var d = primera.getBoundingClientRect().left - grid.getBoundingClientRect().left;
      grid.scrollTo({ left: grid.scrollLeft + d, behavior: 'smooth' });
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#cont-rl-w .rvp-gal-more');
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    cargarMas(b);
  }, true);
  if (window.MutationObserver) new MutationObserver(luego).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', luego); else luego();
})();